/** @badge Native — TG UI Textarea
 *  @when   многострочный ввод: комментарий, заметка, тело сообщения
 *  @not    однострочное поле (имя, поиск, email) — это другой файл, kit/input/Input.tsx
 *  @breaks minHeight не ограничивает рост сверху — длинный текст растягивает textarea без предела
 */
"use client";

import { forwardRef } from "react";
import { Textarea } from "@telegram-apps/telegram-ui";

interface InputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  minHeight?: string;
  style?: React.CSSProperties;
}

export const Input = forwardRef<HTMLTextAreaElement, InputProps>(
  ({ value, onChange, placeholder, minHeight, style }, ref) => (
    <Textarea
      ref={ref}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      style={minHeight ? { minHeight, ...style } : style}
    />
  )
);

Input.displayName = "Input";
